import Enumerable from "linq";
import { FormatStructureEditor } from "../FormatStructureEditor";
import { IFormatAlert } from "../IFormatAlert";
import { IFormatObjectEditable } from "../IFormatObjectEditable";
import { EmptyAlert } from "../alerts/EmptyAlert";
import { DuplicatedObjectIdAlert } from "../alerts/DuplicatedObjectIdAlert";
import { AbstractFormatValidator } from "./AbstractFormatValidator";

export class ObjectIdValidator extends AbstractFormatValidator {
  constructor() {
    super();
  }

  public validate(format: FormatStructureEditor): IFormatAlert[] {
    const duplicatedIdLIst = this.getDuplicatedObjectIdList(format);
    return this.concat(...this.extractObjects(format).map(o => this.validateObject(o, duplicatedIdLIst)));
  }

  private validateObject(object: IFormatObjectEditable, duplicatedIdLIst: number[]): IFormatAlert {
    // ObjectId が設定できないものはチェックしない
    if (!object.id().isEditable()) { return; }

    const id = object.id().getValue();
    if (!id) {
      return new EmptyAlert(object);
    }
    // 重複があるかチェック
    if (Enumerable.from(duplicatedIdLIst).contains(id)) {
      return new DuplicatedObjectIdAlert(object);
    }
  }

  // 重複しているオブジェクトIDのリストを取得
  private getDuplicatedObjectIdList(format: FormatStructureEditor): number[] {
    return Enumerable.from(this.extractObjects(format).filter(o => o.id().isEditable()).map(o => o.id().getValue()))
      .groupBy(i => i)
      .where(g => g.count() > 1)
      .select(g => g.key)
      .select(i => i()).toArray();
  }
}
